(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-titan-rail]').forEach((rail) => {
      if (rail.dataset.ready) return;
      rail.dataset.ready = 'true';
      const track = rail.querySelector('.titan-rail__track');
      const prev = rail.querySelector('[data-rail-prev]');
      const next = rail.querySelector('[data-rail-next]');
      const update = () => {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      [prev, next].forEach((button, i) => button.addEventListener('click', () => {
        track.scrollBy({ left: (i ? 1 : -1) * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
